const esgPassPercent = process.env.REACT_APP_ESG_PASS_SCORE_PERCENT || '85';

export const EsgPlatformStatus = {
  SUCCESS:
    'บริษัทจัดทำ ESG Structured Data และเผยแพร่ ESG Structured Data บนระบบ ESG Data Platform แล้ว',
  WARNING_BELOW_THRESHOLD: `กรุณาจัดทำ ESG Structured Data ภาษาไทย ให้ครอบคลุมอย่างน้อย ${esgPassPercent}%`,
  NOT_FOUND_EN: 'กรุณาจัดทำ ESG Structured Data ภาษาอังกฤษ (ถ้ามี)',
  NOT_FOUND_TH: 'กรุณาจัดทำ ESG Structured Data ภาษาไทย',
  SERVER_ERROR: 'ไม่สามารถโหลดข้อมูลการเปิดเผยข้อมูลจาก ESG Data Platform',
};

export enum EsgProvidePercentLanguage {
  TH = 'TH',
  EN = 'EN',
}
